<div class="page-parent" [ngClass]="{'close':openCloseNav}">  
  
    <ng-container [ngTemplateOutlet]="navTemplate"></ng-container>
    
</div>